/**
 * 物联网设备管理（InternetDeviceManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/InternetDeviceManagement/ 下列表页与命令下发弹窗（第 1 组）
 */
export default {
  // ==================== 通用 ====================
  '当前选择：': 'Currently selected:',
  '取消选择': 'Deselect',
  '请输入区域名称': 'Please enter area name',
  '折叠': 'Collapse',
  '收起': 'Collapse',
  '展开': 'Expand',
  '已选择': 'Selected',
  '项': 'items',
  '导出': 'Export',
  '导出文件': 'Export File',
  '用户信息': 'Customer Info',
  '用户编号': 'Customer No.',
  '用户姓名': 'Customer Name',
  '用户地址': 'Customer Address',
  '用户手机': 'Customer Mobile',
  '用户手机号': 'Customer Mobile Phone',
  '表编号': 'Meter No.',
  '表类型': 'Meter Type',
  '表口径': 'Meter Caliber',
  '表安装地址': 'Meter Installation Address',
  '水表厂商': 'Water Meter Manufacturer',
  '运营商': 'Carrier',
  '自定义列': 'Custom Columns',
  // ==================== 时间查询 ====================
  '查询起止时间': 'Query Time Range',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '上报时间': 'Report Time',
  '上传日期': 'Upload Date',
  '表端时间': 'Meter Time',
  '系统时间': 'System Time',
  // ==================== 表具数据 ====================
  '表具实时数据': 'Meter Real-time Data',
  '表具历史数据': 'Meter History Data',
  '表编号模糊查询': 'Search by meter no.',
  '用户编号模糊查询': 'Search by customer no.',
  '用户姓名模糊查询': 'Search by customer name',
  '用户地址模糊查询': 'Search by customer address',
  '请输入表编号': 'Please enter meter No.',
  '请输入表编号查询': 'Enter meter No. to search',
  '请输入用户编号': 'Please enter customer No.',
  '请输入用户编号查询': 'Enter customer No. to search',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户姓名查询': 'Enter customer name to search',
  '请输入用户地址': 'Please enter customer address',
  '请输入用户手机': 'Enter customer mobile',
  '册号': 'Register No.',
  '请输入册号': 'Please enter register No.',
  '上报方式': 'Report Method',
  '请选择上报方式': 'Please select report method',
  '阀门是否故障': 'Valve Fault',
  '请选择阀门是否故障': 'Please select valve fault',
  '阀门状态': 'Valve Status',
  '请选择阀门状态': 'Select valve status',
  '电池状态': 'Battery Status',
  '请输入电池状态': 'Select battery status',
  '有无磁干扰': 'Magnetic Interference',
  '请输入有无磁干扰': 'Select magnetic interference',
  '请表类型': 'Select meter type',
  '请选择表口径': 'Please select meter caliber',
  '请输入表类型': 'Enter meter type',
  '请选择运营商': 'Select carrier',
  '正常': 'Normal',
  '故障': 'Fault',
  '欠压': 'Undervoltage',
  '有': 'Yes',
  '其他': 'Other',
  '未知': 'Unknown',
  '定时上传': 'Scheduled Upload',
  '上电上传': 'Power-on Upload',
  '手动上传': 'Manual Upload',
  '故障上传': 'Fault Upload',
  '阀门动作上传': 'Valve Action Upload',
  '上报累计流量(m³)': 'Reported Total Flow (m³)',
  '电池电压(V)': 'Battery Voltage (V)',
  '电池电压': 'Battery Voltage',
  '电压范围': 'Voltage Range',
  '电压值最小值': 'Minimum Voltage',
  '电压值最大值': 'Maximum Voltage',
  '请选择': 'Please select',
  '阀控状态': 'Valve Control Status',
  '无阀控': 'No Valve Control',
  '有阀控': 'With Valve Control',
  '日冻结数据': 'Daily Freeze Data',
  '详情': 'Details',
  '间隔流量': 'Interval Flow',
  '密集流量': 'Intensive Flow',
  '历史数据': 'Historical Data',
  '获取抄表数据': 'Get Reading Data',
  '打印抄表卡': 'Print Reading Card',
  '抄表卡(最多500户)': 'Reading Card (max 500 customers)',
  '抄表卡.pdf': 'Reading Card.pdf',
  '文件下载失败': 'File download failed',
  '导出失败': 'Export failed',
  '导出抄表卡PDF失败': 'Failed to export reading card PDF',
  '表号必填!': 'Meter No. is required!',
  '请设置url.list属性!': 'Please set the url.list property!',
  // ==================== 信号分析 ====================
  '信号分析': 'Signal Analysis',
  '信号图形分析': 'Signal Chart Analysis',
  'RSRP区间范围': 'RSRP Range',
  'SNR区间范围': 'SNR Range',
  'CSQ区间范围': 'CSQ Range',
  '信号rsrp值': 'Signal RSRP',
  '信号snr值': 'Signal SNR',
  '信号csq值': 'Signal CSQ',
  '信号覆盖等级': 'Signal Coverage Level',
  '次': 'times',
  '优(>-90)': 'Excellent (>-90)',
  '良(-110--90)': 'Good (-110 ~ -90)',
  '差(<-110)': 'Poor (<-110)',
  '昨日': 'Yesterday',
  '今日': 'Today',
  // ==================== 上报分析 / 上报率 ====================
  '上报分析': 'Reporting Analysis',
  '上报率': 'Reporting Rate',
  '今日上报率': "Today's Reporting Rate: ",
  '近三天上报率': '3-Day Reporting Rate: ',
  '近七天上报率': '7-Day Reporting Rate: ',
  '内部进度条': 'Inner Progress Bar',
  '外部刻度': 'Outer Scale',
  '开阀': 'Open Valve',
  '关阀': 'Close Valve',
  '个': 'pcs',
  // ==================== 批量命令下发 ====================
  '基本数据': 'Basic Data',
  '所选区域': 'Selected Area',
  '所选表号': 'Selected Meter No.',
  '点击选择区域': 'Click to select area',
  '选择': 'Select',
  '导入文件': 'Import File',
  '选择导入文件': 'Select File to Import',
  '任务名称': 'Task Name',
  '请输入任务名称': 'Please enter task name',
  '描述': 'Description',
  '请输入备注': 'Please enter remark',
  '选择命令': 'Select Command',
  '写命令': 'Write Commands',
  '读命令': 'Read Commands',
  '加入队列': 'Add to Queue',
  '加入命令队列': 'Add to Command Queue',
  '批量添加命令模板': 'Batch Add Command Template',
  '下载批量添加命令模板': 'Download Batch Add Command Template',
  '批量添加命令(按区域)': 'Batch Add Commands (By Area)',
  '批量添加命令(按表号)': 'Batch Add Commands (By Meter No.)',
  '批量添加命令(按Excel表号)': 'Batch Add Commands (By Excel Meter No.)',
  '选择批量下发表类型': 'Select Meter Type for Batch Dispatch',
  '请选择表类型': 'Select meter type',
  '请先选择批量下发命令的表类型': 'Please select the meter type for batch command first',
  '请先选择需要批量发送命令的表号': 'Please select the meter No. to send commands first',
  '选择批量下发的表类型不一致不能操作，请重新选择同一表类型的表具': 'Batch sending requires the same meter type. Please re-select meters of the same type',
  '选择的批量下发的表类型不一致不能操作，请重新选择同一表类型的表具信息': 'Batch sending requires the same meter type. Please re-select meters of the same type',
  '请先选择区域': 'Please select an area first',
  '请先选择表号': 'Please select meter No. first',
  '请先上传excel文件': 'Please upload an Excel file first',
  '请先选择命令': 'Please select a command first',
  '只支持.xls格式文件！': 'Only .xls files are supported!',
  '命令下发': 'Send Command',
  '命令队列': 'Command Queue',
  '新协议命令下发': 'New Protocol Send Command',
  '批量命令下发': 'Batch Command Dispatch',
  '批量命令命令下发': 'Batch Command Dispatch',
  '(按区域)': '(By Area)',
  '(按表号)': '(By Meter No.)',
  '(按Excel)': '(By Excel)',
  '命令添加成功,请至【命令队列--命令任务列表】去查看结果': 'Command added successfully. Please check the result in [Command Queue - Command Task List]',
  '命令发送成功': 'Command sent successfully',
  // ==================== 开关阀 / 阀控 ====================
  '开关阀': 'Open/Close Valve',
  '强制开关阀': 'Force Valve Control',
  '控制类型': 'Control Type',
  '请选择控制类型': 'Select control type',
  '请选择阀门控制类型!': 'Please select the valve control type!',
  '取消强制': 'Cancel Force',
  '强制开阀': 'Force Open Valve',
  '强制关阀': 'Force Close Valve',
  '人工阀控-开阀': 'Manual Valve Control - Open',
  '人工阀控-关阀': 'Manual Valve Control - Close',
  '预付费阀控（由系统控制，对标透支是否关阀）': 'Prepaid Valve Control (system-controlled, closes valve on overdraft)',
  '是否带阀': 'With Valve',
  '无阀': 'No Valve',
  '有阀': 'With Valve',
  '是否带阀门': 'With Valve',
  '阀门配置': 'Valve Configuration',
  '阀门堵转功能不开启': 'Valve Stall Protection Disabled',
  '阀门堵转功能开启': 'Valve Stall Protection Enabled',
  '阀门到位超时时间': 'Valve Position Timeout',
  '阀门维护': 'Valve Maintenance',
  '不起用': 'Disabled',
  '启用': 'Enabled',
  '不使能': 'Disabled',
  '使能': 'Enabled',
  '按键开阀使能': 'Open Valve Button Enabled',
  '干扰后是否关阀': 'Close Valve on Interference',
  '不关阀': 'Keep Valve Open',
  '缺电后关阀时间': 'Close Valve Time After Power Loss',
  '缺电是否关阀': 'Close Valve on Low Power',
  '缺电关阀时间': 'Low-Power Close Valve Time',
  '干扰是否关阀': 'Close Valve on Interference',
  '干扰关阀时间': 'Interference Close Valve Time',
  '干扰持续时间': 'Interference Duration',
  '预付费阀门功能': 'Prepaid Valve Function',
  '报警不关阀、透支不关阀': 'Do not close valve on alarm or overdraft',
  '报警关阀、透支不关阀': 'Close valve on alarm, not on overdraft',
  '报警不关阀、透支关阀': 'Close valve on overdraft only',
  '报警关阀、透支关阀': 'Close valve on alarm and overdraft',
  '报警金额': 'Alarm Amount',
  '请输入报警金额': 'Enter alarm amount',
  '透支金额': 'Overdraft Amount',
  '请输入透支金额': 'Enter overdraft amount',
  // ==================== 配置上报/工作参数 ====================
  '配置表上报参数': 'Configure Meter Report Parameters',
  '读取上报参数': 'Read Reporting Parameters',
  '读取表上报参数': 'Read Meter Report Parameters',
  '配置表工作参数': 'Configure Meter Working Parameters',
  '读取表工作参数': 'Read Meter Working Parameters',
  '日上报类型': 'Daily Report Type',
  '24小时随机(1天一次)': '24h random (once a day)',
  '自定义随机(1天一次)': 'Custom random (once a day)',
  '自定义(1天多次)': 'Custom (multiple times a day)',
  '请选择日上报类型!': 'Please select the daily report type!',
  '小时': 'Hour',
  '请选择小时!': 'Please select the hour!',
  '使用设备尾号增加随机性': 'Randomize by Device Suffix',
  '开启': 'On',
  '关闭': 'Close',
  '采集间隔': 'Sampling Interval',
  '请选择采集间隔!': 'Please select the sampling interval!',
  '分': 'min',
  '时': 'h',
  '天': 'Day',
  '周': 'Week',
  '月': 'Month',
  '分钟': 'min',
  '秒': 's',
  '℃': '℃',
  '元': 'CNY',
  '整数': 'Integer',
  '上报周期': 'Reporting Cycle',
  '起始时间': 'Start Time',
  '星期日': 'Sunday',
  '星期一': 'Monday',
  '星期二': 'Tuesday',
  '星期三': 'Wednesday',
  '星期四': 'Thursday',
  '星期五': 'Friday',
  '星期六': 'Saturday',
  '最大失联次数': 'Max Lost-Contact Count',
  '错峰间隔(秒)': 'Staggered Interval (s)',
  '重试次数': 'Retry Count',
  '重试轮数': 'Retry Rounds',
  '工作模式': 'Work Mode',
  '调试模式': 'Debug Mode',
  '用户模式': 'User Mode',
  '试用模式': 'Trial Mode',
  '最大流量': 'Max Flow',
  // ==================== 校时 / 表号 / 密钥 ====================
  '校时': 'Time Sync',
  '校准时间': 'Calibration Time',
  '请输入日期时间': 'Enter date and time',
  '校时方式': 'Time Sync Mode',
  '不启用': 'Disabled',
  'AT指令校时': 'AT Command Time Sync',
  '运营平台校时': 'Platform Time Sync',
  '请输入日期': 'Enter date',
  '写表号': 'Write Meter No.',
  '新表号': 'New Meter No.',
  '请输入新表号': 'Enter new meter No.',
  '新表编号': 'New Meter No.',
  '读表号': 'Read Meter No.',
  '修改运行密匙': 'Modify Operating Key',
  '修改运行秘钥': 'Modify Operating Key',
  '新运行密匙1': 'New Operating Key 1',
  '新运行密匙2': 'New Operating Key 2',
  '新运行密匙3': 'New Operating Key 3',
  '新运行密匙4': 'New Operating Key 4',
  '请输入运行密匙!': 'Please enter the operating key!',
  '请输入正确的表号!': 'Please enter a valid meter No.!',
  '运行秘钥': 'Operating Key',
  '根秘钥': 'Root Key',
  '请输入正确的运行秘钥!': 'Please enter a valid operating key!',
  '请输入正确的根秘钥!': 'Please enter a valid root key!',
  'NB加密使能': 'NB Encryption Enabled',
  '红外加密使能': 'Infrared Encryption Enabled',
  '加密': 'Encrypted',
  '不加密': 'Not Encrypted',
  // ==================== 终端参数（新协议） ====================
  '开始时间': 'Start Time',
  '记录条数': 'Record Count',
  '请选择日期!': 'Please select the date!',
  '请输入查询条数!': 'Please enter the record count!',
  '起始条数': 'Start Record No.',
  '请输入起始条数!': 'Please enter the start record No.!',
  'IP地址': 'IP Address',
  'IP': 'IP',
  'IP输入有误': 'Invalid IP address',
  '端口号': 'Port',
  '端口号输入有误': 'Invalid port number',
  'APN参数': 'APN',
  '即时告警ID': 'Instant Alarm ID',
  '上报离散起始时间': 'Report Spread Start Time',
  '上报离散结束时间': 'Report Spread End Time',
  '上报离散结束估长': 'Report Spread Duration',
  '上报频率': 'Report Frequency',
  '重传次数': 'Retransmission Count',
  '重传间隔': 'Retransmission Interval',
  '失联次数阈值': 'Lost-Contact Count Threshold',
  '激活上报次数': 'Activation Report Count',
  '高频上报功能': 'High-frequency Reporting Function',
  '高频上报周期': 'High-frequency Report Interval',
  '请输入正确的高频上报周期!': 'Please enter a valid high-frequency report interval!',
  '高频上报次数': 'High-Frequency Reporting Count',
  '请输入正确的高频上报次数!': 'Please enter a valid high-frequency reporting count!',
  '电压告警阈值1': 'Voltage Alarm Threshold 1',
  '电压告警阈值2': 'Voltage Alarm Threshold 2',
  '是否启用密集采样': 'Enable Intensive Sampling',
  '密集采样起始时间': 'Intensive Sampling Start Time',
  '密集采样结束时间': 'Intensive Sampling End Time',
  '密集采样时间间隔': 'Intensive Sampling Interval',
  '密集采样天数': 'Intensive Sampling Days',
  '密集采样格式': 'Intensive Sampling Format',
  '是否启用间隔流量采集': 'Enable Interval Flow Sampling',
  '间隔流量采集间隔': 'Interval Flow Sampling Interval',
  '间隔流量数据指示': 'Interval Flow Data Format',
  '上线指令内容设置': 'Online Command Content Settings',
  '日结数据组数': 'Daily Settlement Data Groups',
  '日结数据指示': 'Daily Settlement Data Format',
  '表类型切换': 'Meter Type Switch',
  '平台计费水表': 'Platform-billed Water Meter',
  '表端计费水量表': 'Meter-billed Volume Meter',
  '表端计费金额表': 'Meter-billed Amount Meter',
  '试用量': 'Trial Quantity',
  '单价': 'Unit Price',
  '剩余金额': 'Remaining Balance',
  '最大补包次数': 'Max Packet Retransmission Count',
  '采样间隔': 'Sampling Interval',
  '采样始起始时间': 'Sampling Start Time',
  '采样时长': 'Sampling Duration',
  '采样组数': 'Sampling Groups',
  '压力数据指示': 'Pressure Data Format',
  '压力报警灵敏度': 'Pressure Alarm Sensitivity',
  '压力报警上限': 'Pressure Alarm Upper Limit',
  '压力报警下限': 'Pressure Alarm Lower Limit',
  '温度数据指示': 'Temperature Data Format',
  '温度报警灵敏度': 'Temperature Alarm Sensitivity',
  '温度报警上限': 'Temperature Alarm Upper Limit',
  '温度报警下限': 'Temperature Alarm Lower Limit',
  '过流告警阀值': 'Overcurrent Alarm Threshold',
  '持续过流告警时间': 'Overcurrent Alarm Duration',
  '反流告警阀值': 'Reverse Flow Alarm Threshold',
  '持续反流告警时间': 'Reverse Flow Alarm Duration',
  '故障清除位': 'Fault Clear Flag',
  '故障清除': 'Clear Fault',
  '压力参数设置': 'Pressure Parameter Setting',
  '温度参数设置': 'Temperature Parameter Setting',
  '工作模式设置': 'Working Mode Setting',
  '补包次数阈值': 'Packet Retransmission Threshold',
  '报警参数配置': 'Alarm Parameter Config',
  '设置表底数和脉冲系数': 'Set Meter Base and Pulse Factor',
  '清除表端故障': 'Clear Meter Faults',
  '0~255,255表示不启用': '0~255, 255 means disabled',
  '0-255,255表示不启用': '0-255, 255 means disabled',
  '设置过流告警信息': 'Set Overcurrent Alarm',
  '设置服务器地址': 'Set Server Address',
  '即时告警': 'Instant Alarm',
  '设置上报参数': 'Set Report Parameters',
  '设置电压告警阈值': 'Set Voltage Alarm Threshold',
  '密集采样参数': 'Intensive Sampling Parameters',
  '间隔流量参数': 'Interval Flow Parameters',
  '阀门参数配置': 'Valve Parameter Config',
  '故障参数配置': 'Fault Parameter Config',
  '加密参数': 'Encryption Parameters',
  '设置APN参数': 'Set APN Parameter',
  '上线帧设置': 'Online Frame Setting',
  '表底数': 'Meter Base',
  '请输入表底数': 'Enter meter base',
  '范围:0.01-999999': 'Range: 0.01-999999',
  '脉冲系数': 'Pulse Factor',
  '0.001(1升)': '0.001 (1L)',
  '0.01(10升)': '0.01 (10L)',
  '0.1(100升)': '0.1 (100L)',
  '1(1000升)': '1 (1000L)',
  '终端参数设置': 'Terminal Parameter Settings',
  '查询终端参数': 'Query Terminal Parameters',
  '查询基础信息': 'Query Basic Info',
  '查询实时数据': 'Query Real-time Data',
  '历史日结信息查询': 'Daily Settlement History Query',
  '阀门动作记录查询': 'Valve Action Record Query',
  '联网失败记录': 'Network Failure Records',
  '终端故障记录': 'Terminal Fault Records',
  '开阀(强制)': 'Open Valve (Forced)',
  '关阀(强制)': 'Close Valve (Forced)',
  '取消阀控': 'Cancel Valve Control',
  '修改根秘钥': 'Modify Root Key',
  '清除类型': 'Clear Type',
  '不清除故障': 'Do Not Clear Fault',
  '清除故障': 'Clear Fault',
  '清除外接EEPROM内的数据': 'Clear External EEPROM Data',
  '清除表端数据': 'Clear Meter Data',
  '日结累计流量两字节': 'Daily Settlement Total Flow (2 bytes)',
  '日结累计流量四字节': 'Daily Settlement Total Flow (4 bytes)',
  '日结累计正流量和日结累计负流量两字节': 'Daily Settlement Forward & Reverse Total Flow (2 bytes)',
  '日结累计正流量和日结累计负流量四字节': 'Daily Settlement Forward & Reverse Total Flow (4 bytes)',
  '日用量两字节': 'Daily Usage (2 bytes)',
  '日用量四字节': 'Daily Usage (4 bytes)',
  // ==================== 读取命令（老协议） ====================
  '读取表具信息': 'Read Meter Info',
  '读取网络参数': 'Read Network Parameters',
  '读取表网络参数': 'Read Meter Network Parameters',
  '配置表网络参数': 'Configure Meter Network Parameters',
  '读取表历史数据': 'Read Meter History Data',
  '起始冻结日期': 'Start Freeze Date',
  '请输入起始冻结日期': 'Enter start freeze date',
  '读取模组IMEI号': 'Read Module IMEI',
  'IMEI号': 'IMEI No.',
  '读取模组版本号': 'Read Module Version',
  '读取模组状态': 'Read Module Status',
  '读取SIM卡号': 'Read SIM Card No.',
  'sim卡号': 'SIM Card No.',
  '表端自检功能': 'Meter Self-Check',
  '自检内容': 'Self-Check Content',
  '只检测阀门': 'Valve Only',
  '全检': 'Full Check',
  '读取最近10次阀门动作原因': 'Read Last 10 Valve Action Reasons',
  '读取程序版本信息': 'Read Program Version Info',
  '读取最近10次联网失败原因': 'Read Last 10 Network Failure Reasons',
  '读取最近10次表端故障原因': 'Read Last 10 Meter Fault Reasons',
  '读取表端最近10次磁干扰故障': 'Read Last 10 Magnetic Interference Faults',
  '模块初始化配置': 'Module Initialization Config',
  // ==================== 信号/电压图形分析 tab ====================
  '电池电压分析': 'Battery Voltage Analysis',
  '电池电压图形分析': 'Battery Voltage Chart Analysis',
}
